import React from "react";
import { Redirect, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { observer, inject } from "mobx-react";
import compose from "recompose/compose";
import queryString from "query-string";
import { graphql } from "@apollo/client/react/hoc";
import { REVIEWS_AGGREGATE_QUERY_V2, TARIFFS_FOR_REVIEWS_PROVIDER } from "Services/queries";
import { DECLINATION_QUERY } from "Configs/queries";
import { sendMetriks } from "Services/sendMetriks";
import { generateUrl } from "Services/withDefaultParams";
import { variablesFromRouter } from "Services/QueryBuilder";
import withDefaultParams from "Services/withDefaultParams";
import Routes from "Configs/routes";
import { Redirect404, RedirectPagination } from "ComponentsUI/Redirects";
import { PaddingTop } from "ComponentsUI/Spacings";
import { Paginator, PaginatorElem } from "ComponentsUI/Pagination";
import Block from "ComponentsUI/Block";
import FiltersContainer from "./Containers/Filters";
import ReviewListContainer from "./Containers/ReviewListContainer";
import Stub from "./Containers/Stub";
import { isMainSiteCode } from "Utils/siteConfig";

const LIMIT = 10;

@inject("ApplicationModel")
@observer
class ReviewsList extends React.Component {
	componentDidMount() {
		const {
			ApplicationModel: { providerModel },
		} = this.props;
		if (providerModel.visibleTab === "provider_tab_card") {
			providerModel.changeTab("provider_tab_review");
		}
		let reviewsLoading = this.props.data.loading;
		if (!reviewsLoading) {
			if (this.props.providerForCard.vip_provider) {
				sendMetriks("OPEN_OTZYVY_VIP");
			} else {
				sendMetriks("OPEN_OTZYVY_NEVIP");
			}
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		let reviewsLoading = this.props.data.loading;
		let prevReviewsLoading = prevProps.data.loading;
		if (prevReviewsLoading && !reviewsLoading) {
			if (this.props.providerForCard.vip_provider) {
				sendMetriks("OPEN_OTZYVY_VIP");
			} else {
				sendMetriks("OPEN_OTZYVY_NEVIP");
			}
		}
	}

	onChangePageHandler(page) {
		let {
			ApplicationModel: { filtersModel },
			match: { params, url },
		} = this.props;
		let ReviewsUrl = "";
		if (page == 1) {
			ReviewsUrl = generateUrl(Routes.ProvidersReviewListOld.route, {
				regionUrl: params.regionUrl,
				providerName: params.providerName,
			});
		} else {
			ReviewsUrl = generateUrl(Routes.ProvidersReviewListOld.route, {
				regionUrl: params.regionUrl,
				providerName: params.providerName,
				page: page,
			});
		}

		if (filtersModel.selectedFiltersUrl) {
			this.props.history.push({
				pathname: ReviewsUrl,
				search: filtersModel.selectedFiltersUrl,
			});
		}
	}

	canonical() {
		const {
			ApplicationModel: { siteConfig },
		} = this.props;

		const location = generateUrl(Routes.ProvidersReviewListOld.route, {
			regionUrl: this.props.match.params.regionUrl,
			providerName: this.props.match.params.providerName,
		});

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	}

	render() {
		let {
			ApplicationModel: { text, windowSizeModel: windowSizesModel },
			data,
			region,
		} = this.props;

		let tariffsForReviewsProvider = this.props.tariffs;
		const siteCode = this.props.ApplicationModel.siteCode;

		let titleText = {
			provider: !!this.props.providerForCard ? this.props.providerForCard.name : "",
			region: !!this.props.region ? this.props.region.declinations : "",
		};

		if (!data || !data.reviewsProvidersV2 || !this.props.providerForCard || !region) {
			return <Stub />;
		}

		if (this.props.match.params.page === "1") {
			return <RedirectPagination />;
		}

		if (this.props.data?.reviewsProvidersV2?.pagination?.items_total == 0) {
			const link = generateUrl(Routes.ProviderRates.route, {
				regionUrl: this.props.match.params.regionUrl,
				providerName: this.props.match.params.providerName,
			});
			return <Redirect to={link} />;
			// return <Redirect404 />;
		}

		let reviews = this.props.data.reviewsProvidersV2.data;
		let provider = this.props.providerForCard;

		// Добавление description к микроразметке
		let homeOrderType = provider?.rating?.order_types.find((item) => item.order_type_id === 1);
		let countReviews = homeOrderType?.review_all;
		let textReviews = "";
		if (countReviews % 10 === 1) {
			if (countReviews.toString().substring(-2) === "11") {
				textReviews = text.REVIEW_2;
			} else {
				textReviews = text.REVIEW_1;
			}
		} else {
			textReviews = text.REVIEW_2;
		}

		let textDescription = `${text.orderRatingProviderHome_1} ${
			provider.name
		} ${text.orderRatingProviderHome_2} ${
			region.declinations.prepositional
		} ${text.orderRatingProviderHome_3} ${
			!!homeOrderType ? countReviews : 0
		} ${textReviews} ${text.orderRatingProviderHome_4}`;

		let page = 1;
		if (this.props.match.params.page) {
			page = parseInt(this.props.match.params.page);
		}

		let pagination = this.props.data.reviewsProvidersV2.pagination;
		let pageTotal = Math.ceil(pagination.items_total / LIMIT);

		pagination = {
			...pagination,
			per_page: LIMIT,
			page_current: page,
			page_total: pageTotal,
		};

		if (!page || pagination.items_total <= LIMIT * (page - 1)) {
			return <Redirect404 message404={"Используется несуществвующая страница в пагинации"} />;
		}

		let path = generateUrl(Routes.ProvidersReviewListOld.route, {
			regionUrl: this.props.match.params.regionUrl,
			providerName: this.props.match.params.providerName,
		});

		let sortedAggregation = {};

		let aggregateRating = provider.rating;

		let orderTypeHome = aggregateRating?.order_types.find((item) => item.order_type_id === 1);

		let rating_avg = ((orderTypeHome?.rating || 0) / 10).toFixed(1);
		return (
			<>
				{this.canonical()}
				{isMainSiteCode(siteCode) && <div></div>}
				<PaddingTop>
					<Block>
						<div itemScope itemType="http://schema.org/Product">
							<meta itemProp="name" content={provider.name} />
							<meta itemProp="description" content={textDescription} />
							<div
								itemScope
								itemProp="aggregateRating"
								itemType="http://schema.org/AggregateRating"
							>
								<meta itemProp="worstRating" content={0} />
								<meta itemProp="ratingValue" content={rating_avg} />
								<meta itemProp="bestRating" content={aggregateRating.rating_max} />
								<meta itemProp="reviewCount" content={pagination.items_total} />
							</div>
							<FiltersContainer aggregation={sortedAggregation} provider={provider} />
							<ReviewListContainer
								providerId={provider.id}
								provider_settings={provider.provider_settings}
								vipProvider={provider.vip_provider}
								items={reviews}
								tariffsForReviewsProvider={tariffsForReviewsProvider}
								titleText={titleText}
								providerReviews={true}
								pageName={"no_vip_rating"}
								withReply={true}
							/>
						</div>
					</Block>
					<Paginator
						location={this.props.location}
						itemsTotal={pagination.items_total}
						itemsPerPage={LIMIT}
						pageCurrent={pagination.page_current}
						pageTotal={pagination.page_total}
						windowSizes={windowSizesModel.windowSizes}
						urlDefault={path}
						wrapperItem={<PaginatorElem />}
						onChangePage={(page) => this.onChangePageHandler(page)}
					/>
				</PaddingTop>
			</>
		);
	}
}

export default withRouter(
	withDefaultParams(
		variablesFromRouter(
			compose(
				graphql(REVIEWS_AGGREGATE_QUERY_V2, {
					skip: (ownProps) => {
						return ownProps.match.params.regionUrl ? false : true;
					},
					options: (props) => {
						let parsedParams = queryString.parse(props.location.search);
						let page = 1;
						if (props.match.params.page) {
							page = parseInt(props.match.params.page);
						}
						let offset = LIMIT * (page - 1);
						let sort;
						switch (parsedParams?.sort) {
							case "useful":
								sort = "-real,-date";
								break;
							case "old":
								sort = "date";
								break;
							default:
								sort = "-date";
						}

						let filter = props.variables.filter;
						let parsedFilter = filter.split("&");
						if (!!parsedParams.withAnswer) {
							parsedFilter.push("answers.count > 0");
						}

						if (!!parsedParams.specs) {
							parsedFilter.push(`specifications.list.id=${parsedParams.specs}`);
						}

						filter = parsedFilter.join("&");

						return {
							variables: {
								...props.variables,
								offset: offset,
								limit: LIMIT,
								filter: filter,
								sort: sort,
								goodView: sort === "-real,-date",
								providerJoin: true,
							},
						};
					},
				}),
				graphql(DECLINATION_QUERY, {
					skip: (ownProps) => {
						return ownProps.match.params.regionUrl ? false : true;
					},
					options: (props) => {
						let {
							match: {
								params: { regionUrl },
							},
						} = props;
						return {
							variables: {
								filter: `url=${regionUrl}`,
							},
						};
					},
					props: ({ data }) => {
						if (data.region) {
							return data;
						}
						return null;
					},
				}),
				graphql(TARIFFS_FOR_REVIEWS_PROVIDER, {
					skip: (ownProps) => {
						let vipProvider = !!ownProps.providerForCard.vip_provider;
						let providerName = ownProps.match?.params?.providerName || true;
						let regionName = ownProps.match?.params?.regionUrl || true;
						return !vipProvider && !providerName && !regionName;
					},
					options: (props) => {
						let {
							match: {
								params: { regionUrl, providerName },
							},
						} = props;
						return {
							variables: {
								regionUrl: regionUrl,
								providerUrl: providerName,
								limitTariffs: 3,
								providerJoin: true,
							},
						};
					},
					props: ({ data }) => {
						if (data.tariffsForReviewsProvider && data.tariffsForReviewsProvider.data) {
							return {
								tariffs: data.tariffsForReviewsProvider.data,
							};
						}
						return {
							tariffs: [],
						};
					},
				})
			)(ReviewsList)
		)
	)
);
